import { render, staticRenderFns } from "./ManagePlayers.vue?vue&type=template&id=6c1d080b&"
import script from "./ManagePlayers.vue?vue&type=script&lang=js&"
export * from "./ManagePlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports